import { isEmpty } from '../isEmpty';
import { filterTypes } from '../pax/filterTypes';
/**
 * Convert from redux door type to a format that S1 expects
 * @param doorType Guida redux door type.
 * @returns S1 door type
 */
export const convertDoorType = (doorType) => {
    switch (doorType) {
        case 'door':
            return 'hinged';
        case 'no_door':
            return 'none';
        case 'sliding':
            return 'sliding';
        default:
            return 'none';
    }
};
export const buildLabel = (storageTypes, signifiers, articleSignifiers) => {
    if (isEmpty(signifiers)) {
        return '';
    }
    const relevantSignifiers = articleSignifiers.filter(signifier => signifiers.includes(signifier.type));
    if (!isEmpty(relevantSignifiers)) {
        const totalRelevance = relevantSignifiers.reduce((acc, curr) => acc + curr.relevance, 0);
        if (totalRelevance > 0.03 && storageTypes[0] === 'hanging') {
            return 'guid01ReLabelHanging';
        }
        if (totalRelevance > 0.3) {
            if (storageTypes[0] === 'shoes') {
                return 'guid01ReLabelShoes';
            }
            if (storageTypes[0] === 'folding') {
                return 'guid01ReLabelFolded';
            }
        }
        return '';
    }
    return '';
};
export const buildFlatImage = (images) => {
    if (isEmpty(images)) {
        return undefined;
    }
    return images?.find(image => image.typeCode === 'open-design-image');
};
export const buildAngledImage = (images) => {
    if (isEmpty(images)) {
        return undefined;
    }
    return images?.find(image => image.typeCode === 'open-design-image-angled');
};
/**
 * Return image url for main-design-image. Will include doors if existing.
 * @param images
 * @returns Image url for main-design-image
 */
export const buildImageMain = (images) => {
    if (isEmpty(images)) {
        return undefined;
    }
    return images?.find(image => image.typeCode === 'main-design-image');
};
export const buildHomeDeliveryItems = (itemList) => {
    return itemList.map(item => {
        return {
            id: item.id,
            type: item.type
        };
    });
};
/**
 * Build a list of shoppingProducts given an item list from an article.
 * @param itemList The items.
 * @param products The products.
 * @returns An array of shoppingProducts
 */
export const buildShoppingProducts = (itemList, products) => {
    const articles = itemList
        .map(item => {
        const article = products.find(product => item.id === product.id);
        return {
            ...article,
            ...item
        };
    })
        .filter(item => item.product);
    const selectedArticles = articles.filter(item => !filterTypes(item.product?.content?.mainTypeName));
    const shoppingProducts = selectedArticles.map(item => ({
        quantity: item.quantity,
        product: item.product
    }));
    return shoppingProducts;
};
//# sourceMappingURL=index.js.map